



















import { transformLocations } from '@tt4b/ttam-utils';
import { useStore, StateEnum } from '@tt4b/ttam-hooks';
import { computed, defineComponent } from '@vue/composition-api';
import QuestionTooltip from 'src/components/common/question-tooltip/index.vue';
import { trackEvent } from './../../../../utils/index';

const name = 'ttam-audience-size-main-title';
export default defineComponent({
  components: {
    QuestionTooltip,
  },
  setup() {
    const { state } = useStore();
    const areaData = state[StateEnum.areaData].data;
    const areaMap = computed(() => areaData?.value?.areaMap ?? {});
    transformLocations({
      particleLocations: [0],
      locationParams: {
        areaMap: areaMap.value ?? {},
        isSplitTestBidding: false,
        isSplitTestCreative: false,
      },
    });

    const trackClick = () => {
      trackEvent('create_AS_learnMore_click');
    };
    return {
      name,
      trackClick,
    };
  },
});
